import { matchesSearch, LookupField, createLookupModel } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { Col, Row } from 'reactstrap';
import Checkbox from 'src/componentes/checkbox';
import ProcessoLookup from 'src/lookups/processo';
import ControleLookup from 'src/lookups/ControleLookup';
import CausaRiscoLookup from 'src/lookups/causa-risco';
import ConsequenciaRiscoLookup from 'src/lookups/consequencia-risco';
import CollapsibleSection from 'src/componentes/CollapsibleSection';

/**
 * Seção de Relacionamentos
 */
const RelationshipsSection = ({
  model,
  resources,
  intl,
  configuracao,
  searchQuery,
}) => {
  const fields = [
    configuracao?.utilizarCausaRisco && {
      label: intl.formatMessage(
        { id: 'labelCausasDoRisco' },
        {
          pontosproblematicos: resources.pontosproblematicos,
          risco: resources.risco,
        }
      ),
      id: 'causasRisco',
    },
    configuracao?.utilizarConsequenciaRisco && {
      label: intl.formatMessage(
        { id: 'labelConsequenciasDoRisco' },
        {
          consequencias: resources.consequencias,
          risco: resources.risco,
        }
      ),
      id: 'consequenciasRisco',
    },
    {
      label: resources?.pontosdecontrole,
      id: 'controles',
    },
    {
      label: intl.formatMessage(
        { id: 'label.processos' },
        { processos: resources.processos }
      ),
      id: 'processos',
    },
    {
      label: intl.formatMessage({ id: 'incluirSubprocessos' }),
      id: 'incluirSubprocessos',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;
  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.relacionamentos' })}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {configuracao?.utilizarCausaRisco &&
          visibleFields.includes(
            fields.find((f) => f.id === 'causasRisco')
          ) && (
            <Col md={12}>
              <LookupField
                Component={CausaRiscoLookup}
                multi
                clearable
                highlight={matchesSearch(
                  intl.formatMessage(
                    { id: 'labelCausasDoRisco' },
                    {
                      pontosproblematicos: resources.pontosproblematicos,
                      risco: resources.risco,
                    }
                  ),
                  searchQuery
                )}
                model={createLookupModel(
                  intl.formatMessage(
                    { id: 'labelCausasDoRisco' },
                    {
                      pontosproblematicos: resources.pontosproblematicos,
                      risco: resources.risco,
                    }
                  ),
                  model.getModel('causasRisco')?.value,
                  model.getModel('causasRisco')?.requestChange
                )}
              />
            </Col>
          )}

        {configuracao?.utilizarConsequenciaRisco &&
          visibleFields.includes(
            fields.find((f) => f.id === 'consequenciasRisco')
          ) && (
            <Col md={12}>
              <LookupField
                Component={ConsequenciaRiscoLookup}
                multi
                clearable
                highlight={matchesSearch(
                  intl.formatMessage(
                    { id: 'labelConsequenciasDoRisco' },
                    {
                      consequencias: resources.consequencias,
                      risco: resources.risco,
                    }
                  ),
                  searchQuery
                )}
                model={createLookupModel(
                  intl.formatMessage(
                    { id: 'labelConsequenciasDoRisco' },
                    {
                      consequencias: resources.consequencias,
                      risco: resources.risco,
                    }
                  ),
                  model.getModel('consequenciasRisco')?.value,
                  model.getModel('consequenciasRisco')?.requestChange
                )}
              />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'controles')) && (
          <Col md={12}>
            <LookupField
              Component={ControleLookup}
              multi
              clearable
              highlight={matchesSearch(
                resources?.pontosdecontrole,
                searchQuery
              )}
              model={createLookupModel(
                resources?.pontosdecontrole,
                model.getModel('controles')?.value,
                model.getModel('controles')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'processos')) && (
          <Col md={12}>
            <LookupField
              Component={ProcessoLookup}
              multi
              highlight={matchesSearch(
                intl.formatMessage({ id: 'label.processos' }),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'label.processos' },
                  { processos: resources.processos }
                ),
                model.getModel('processos')?.value,
                model.getModel('processos')?.requestChange
              )}
              data={{ TipoId: 5 }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'incluirSubprocessos')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'incluirSubprocessos' },
                  {
                    processosfilhosplural:
                      resources.processosfilhosplural.toLowerCase(),
                  }
                ),
                model.getModel('incluirSubprocessos')?.value,
                model.getModel('incluirSubprocessos')?.requestChange
              )}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};
export default RelationshipsSection;